import 'focus-visible';

export default defineNuxtPlugin((nuxtApp) => {

});
  